import React from 'react'
import {useSelector} from 'react-redux'
import moment from 'moment';
import {Fragment} from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import {useFormContext} from "react-hook-form";
import FlaveRadioButtonCheckbox from "./form_fields/raw_fields/flave_radio_button_checkbox";
import FlaveDropdown from "./form_fields/raw_fields/flave_dropdown";
import useLiquid from 'src/shared/service/use_liquid'

const EventGroupHeaderFooter = ({text}) => {
  const isBootstrapHorizontal = useSelector(state => state.form_field_style) === "boostrap_horizontal"

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"

  if (!text) {
    return null
  }

  return <div className="row event-group-header">
    <div className={classNames("", {"col-md-12": !isBootstrapHorizontal, [`col-md-${inputWidth} offset-md-${labelWidth}`]: isBootstrapHorizontal})}
    >
      <RenderedHtmlContent html={text}/>
    </div>
  </div>
}

const eventGroupName = (fieldType, eventGroup) => {
  return `event_groups.${fieldType}.group_${eventGroup.id}`
}

const EventGroup = ({fieldType, eventGroup}) => {
  const {formState: { errors }, clearErrors} = useFormContext();
  const eventGroups = useSelector(state => state.event_groups)
  const eventGroupNames = _.map(eventGroups, (eg, i) => eventGroupName(fieldType, eg))
  const error = errors.event_groups?.[fieldType]?.["group_" + eventGroup.id]?.message;

  const selectionMode = eventGroup.selection_mode || "radio"
  const renderLiquid = useLiquid()

  const handleEventGroupChange = () => {
    clearErrors(eventGroupNames)
  }

  const dropdownOptions = []
  const radioOptions = []
  _.map(eventGroup.events, (event, i) => {
    //const hasEventGroupError = errors.event_groups?.[fieldType]?.["group_" + eventGroup.id]
    const selectionMode = eventGroup.selection_mode || "radio"
    const limitReached = event.limit && event.free_places <= 0

    const language = useSelector(state => state.language)
    let freePlacesText = "Freie Plätze: "
    let beginsAtText = `Beginn: ${moment(event.begins_at).format('dd, DD.MM.YYYY HH:mm')} Uhr`
    let endsAtText = `Ende: ${moment(event.begins_at).format('dd, DD.MM.YYYY HH:mm')} Uhr`
    let limitReachedText = " - ausgebucht"

    if (language && language != "de") {
      freePlacesText = "Free Places: "
      beginsAtText = `Start: ${moment(event.begins_at).format('dd, DD.MM.YYYY HH:mm')}`
      endsAtText = `End: ${moment(event.begins_at).format('dd, DD.MM.YYYY HH:mm')}`
      limitReachedText = " - fully booked"
    }

    let bookingStatusText = event.free_places;
    if (limitReached) {
      bookingStatusText = limitReachedText
    }

    radioOptions.push({
      value: event.id,
      label: <>
        <RenderedHtmlContent html={event.alternative_title || event.title}/>
        <div className="event-dates">
          {(eventGroup.show_free_places && event.limit) && <div className="event-places">
            {freePlacesText}
            {bookingStatusText}
          </div>}
          {eventGroup.show_event_begins_at && event.begins_at && <div className="event-date">{beginsAtText}</div>}
          {eventGroup.show_event_ends_at && event.ends_at && <div className="event-date">{endsAtText}</div>}
        </div>
      </>,
      disabled: limitReached
    })

    let label = eventGroup.alternative_event_title || event.alternative_title || event.title

    dropdownOptions.push({
      value: event.id,
      label: renderLiquid(label, {eventGroup: eventGroup, event: event, limitReached: limitReached}),
      disabled: limitReached
    })

  })

  if(eventGroup.render_type == "dropdown") {
    return <FlaveDropdown
      name={eventGroupName(fieldType, eventGroup)}
      type={selectionMode}
      label={eventGroup.title}
      options={dropdownOptions}
      errorMessage={error}
    />

  } else {
    return <FlaveRadioButtonCheckbox
      name={eventGroupName(fieldType, eventGroup)}
      type={selectionMode}
      label={eventGroup.title}
      options={radioOptions}
      errorMessage={error}
      onChange={handleEventGroupChange}
    />

  }
}

const EventGroups = ({fieldType}) => {
  const eventGroups = useSelector(state => state.event_groups)
  const eventGroupsHeader = useSelector(state => state.event_groups_header)

  return <>
    {eventGroupsHeader && <RenderedHtmlContent html={eventGroupsHeader}/>}
    {_.map(eventGroups, (eventGroup, i) => {
      return <Fragment key={`event_groups_${eventGroup.id}`}>
        {eventGroup.header_text && <EventGroupHeaderFooter text={eventGroup.header_text}/>}
        <EventGroup eventGroup={eventGroup} fieldType={fieldType}/>
        {eventGroup.footer_text && <EventGroupHeaderFooter text={eventGroup.footer_text}/>}
      </Fragment>
    })}
  </>
}

export default EventGroups;
